module.exports = "/static/assets/9eb60af40878e5ef0e60f56a87123424.png";